<ng-template [appToastTemplate]="toastKey" let-message>
  <div class="lane-auto-redeem-toast">
    <div class="lane-auto-redeem-toast__title">
      <span>{{ message.summary }}</span>
    </div>
    <!-- CWS-1053: only claim a gate is opening when one actually is. -->
    <div class="lane-auto-redeem-toast__status" role="status" *ngIf="message.data?.gateOpening">
      <span class="lane-auto-redeem-toast__pulse" aria-hidden="true"></span>
      <span class="lane-auto-redeem-toast__status-label">Gate opening</span>
    </div>
    <p class="lane-auto-redeem-toast__detail" *ngIf="message.detail">{{ message.detail }}</p>
    <button type="button" class="lane-auto-redeem-toast__open" (click)="onOpenDetails(message)">
      Open details
    </button>
  </div>
</ng-template>
